// VulnTask Configuration
// NOTE: This is an intentionally vulnerable demo app for security testing

// ===== Secrets (intentional — for scanner detection) =====
export const STRIPE_SECRET_KEY = "sk_test_51HG8k2CjzKL9mN4oP5qR6sT7uV8wX9yZ0aB1cD2eF3gH4iJ5kL6";
export const GOOGLE_API_KEY = "AIzaSyDm3kF8gH2jK4lM5nP6qR7sT8uV9wX0yZ1aB";
export const GITHUB_TOKEN = "ghp_a1B2c3D4e5F6g7H8i9J0k1L2m3N4o5P6q7R8";
export const SENDGRID_API_KEY = "SG.a1B2c3D4e5F6g7H8.i9J0k1L2m3N4o5P6q7R8s9T0u1V2w3X4y5Z6";
export const SLACK_WEBHOOK = "https://hooks.slack.com/services/T01A2B3C4/B05D6E7F8/g9H0iJ1kL2mN3oP4qR5sT6u";
export const JWT_SECRET = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiYWRtaW4iOnRydWV9";
export const DATABASE_URL = "postgresql://admin:SuperSecret123!@db.vulntask.internal:5432/vulntask_prod";
export const ADMIN_PASSWORD = "admin123!@#";

// ===== Environment Variables =====
export const API_BASE_URL = import.meta.env.VITE_API_URL || "https://api.vulntask.dev";
export const WS_URL = import.meta.env.VITE_WS_URL || "wss://ws.vulntask.dev";
export const APP_ENV = import.meta.env.VITE_APP_ENV || "development";
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN || "";
export const GA_TRACKING_ID = import.meta.env.VITE_GA_ID || "G-XXXXXXXXXX";

// ===== Feature Flags =====
export const FF_DARK_MODE = true;
export const FF_NEW_DASHBOARD = import.meta.env.VITE_FF_NEW_DASHBOARD === "true";
export const FEATURE_TASK_COMMENTS = true;
export const FEATURE_AI_SUGGESTIONS = false;
export const FF_ENABLE_WEBSOCKET = true;
